// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"67":"50ca7f6a","915":"54fe1c5c"}[chunkId] + ".chunk.js";
};